import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Box } from 'reflexbox/styled-components'

import { ButtonStyled } from '@anvilco-pkg/ui/components/Button'

import baseTheme from 'theme'

export const PAPER_PADDING = '30px'
export const DESKTOP_PAPER_PADDING_Y = '64px'
export const DESKTOP_PAPER_PADDING_X = '50px'

const PaperContainer = styled(Box)
  .attrs(({ padded, mobilePadded, noMobileTabletPadding }) => ({
    px: padded
      ? [
          mobilePadded ? 18 : noMobileTabletPadding ? 0 : PAPER_PADDING,
          noMobileTabletPadding ? 0 : PAPER_PADDING,
          DESKTOP_PAPER_PADDING_X,
        ]
      : [],
    py: padded
      ? [
          noMobileTabletPadding ? 0 : PAPER_PADDING,
          noMobileTabletPadding ? 0 : PAPER_PADDING,
          DESKTOP_PAPER_PADDING_Y,
        ]
      : [],
    pb: padded ? [50] : [],
  }))
  .withConfig({
    shouldForwardProp: (prop) =>
      ['padded', 'mobilePadded'].indexOf(prop) === -1,
  })`
  margin: 0 auto;
  position: relative;
  min-width: 0px;
  max-width: ${baseTheme.paperMaxWidth}px;
  width: 100%;

  height: min-content;

  background: white;
  box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.08);

  overflow: ${({ overflow }) => overflow};

  a:not(${ButtonStyled}):not([name]) {
    text-decoration: underline;
    color: ${baseTheme.colors.black};
    font-weight: ${baseTheme.fontWeights.bold};

    :hover {
      text-decoration: none;
      color: ${({ theme }) =>
        theme?.textColors?.linkHover || baseTheme.textColors.linkHover};
    }
  }
`

PaperContainer.defaultProps = {
  overflow: 'visible',
}

PaperContainer.propTypes = {
  padded: PropTypes.bool,
  overflow: PropTypes.oneOf(['visible', 'hidden']),
}

export default PaperContainer
